import EasyQR from 'easyqrcodejs'
import useCommonTodo from '@/views/apps/todo/useCommonTodo'

// Genera un token aleatorio alfanumérico para el QR
export const generateToken = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const bytes = new Uint8Array(10)
  crypto.getRandomValues(bytes)
  return Array.from(bytes, byte => chars[byte % chars.length]).join('')
}

// Devuelve la URL base de un QR (sin el query param de token)
export const qrBaseURL = url => (url || '').split('?')[0]

// Agrega (o reemplaza) el token de un QR en su URL
export const withToken = (baseUrl, token) => `${qrBaseURL(baseUrl)}?t=${token}`

// Renderiza el QR en un contenedor (opcional) y devuelve el canvas
export const renderQRCode = (text, container = null) => {
  const target = container || document.createElement('div')
  // eslint-disable-next-line no-new
  new EasyQR(target, { text, width: 800, height: 800 })
  return target.querySelector('canvas')
}

// Auxiliary functions for compression 1
const base64ToBlob = (base64, type) => {
  const byteCharacters = atob(base64)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)
  return new Blob([byteArray], { type })
}

// Auxiliary functions for compression 2
const compressBase64Image = (base64, maxWidth = 640, quality = 0.85) => new Promise(resolve => {
  const img = new Image()
  img.src = base64

  img.onload = () => {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')

    let { width, height } = img
    const ratio = width / height

    if (width > maxWidth) {
      width = maxWidth
      height = maxWidth / ratio
    }

    canvas.width = width
    canvas.height = height

    ctx.drawImage(img, 0, 0, width, height)

    resolve({
      base64: canvas.toDataURL('image/jpeg', quality),
      width,
      height,
    })
  }
})

// Comprime y sube la imagen del QR a S3, devuelve el key
export const uploadQRImage = async (canvas, fileName, clientId) => {
  try {
    if (!canvas) return undefined
    const { base64 } = await compressBase64Image(canvas.toDataURL('image/png'))
    const jpegBase64 = base64.split(',')[1]
    const blob = base64ToBlob(jpegBase64, 'image/jpeg')

    const fileInfo = {
      name: fileName,
      type: 'image/jpeg',
      file: blob,
    }

    const destinationFolder = `${clientId}/qr-code`
    const { uploadFileToS3 } = useCommonTodo()
    return uploadFileToS3(fileInfo, destinationFolder)
  } catch (error) {
    console.log(error)
    return undefined
  }
}
